import { useState, useEffect } from 'react';
import { getSuccessReports } from '../services/apiGateway';

function useSuccessReports(setLoading) {
  const [successReports, setSuccessReports] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      const response = await getSuccessReports(abortController.signal);
      setSuccessReports(response ? response.data : []);
      if (setLoading) {
        setLoading(false);
      }
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return successReports;
}

export default useSuccessReports;
